<template>
    <div class="B2BGetToKnow mb-10 lg:mb-20">
        <div class="container">
            <!-- stack < md, row on md+, equal heights -->
            <div class="flex flex-col md:flex-row items-stretch overflow-hidden rounded-lg bg-white dark:bg-surface-card shadow">
                <!-- VIDEO -->
                <div class="flex-1 min-w-0 relative overflow-hidden md:h-[454px] lg:h-auto lg:aspect-video">
                    <CEmbedVideo
                        video-id="rObgBWcB6zc"
                        :responsive="true"
                        :lite="false"
                        class="size-full"
                    />
                </div>

                <!-- TEXT -->
                <div class="w-full min-w-0 md:max-w-[40%] px-5 py-9 md:px-6 md:py-10 text-left lg:flex lg:flex-col lg:justify-center">
                    <CHeading class="mb-6 font-bold" variant="3">Spoznajte projekt GROWNi</CHeading>

                    <p>GROWNi je súčasťou neziskovej organizácie LEAF.</p>
                    <p class="mt-3">Na tvorbe platformy sa podieľali aj zakladateľky programu DASATO (I AMbitious).</p>

                    <div class="mt-4 flex w-full flex-row items-center justify-evenly gap-2 md:justify-between">
                        <a class="inline-flex" href="https://growni.sk/orgs/leaf" target="_blank">
                            <img
                                alt="Leaf logo"
                                class="mt-2 w-32"
                                loading="lazy"
                                src="/images/partneri/logo-leaf.png"
                            />
                        </a>

                        <a class="inline-flex" href="https://growni.sk/orgs/i-ambitious" target="_blank">
                            <img
                                alt="DASATO academy logo"
                                class="mt-2 w-32"
                                loading="lazy"
                                src="/images/partneri/logo-dasato.png"
                            />
                        </a>
                    </div>

                    <div class="flex w-full justify-center pt-6">
                        <CButton size="large" style="width: 256px" :to="{ name: 'about' }" variant="primary">
                            Viac o GROWNi
                        </CButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

